import gql from "graphql-tag";

export const MY_LEAVE_DELETE_REQUEST = gql`
  mutation deleteLeaveRequest(
    $_id: String!
    $locale: String!
    $message: String
  ) {
    deleteLeaveRequest(_id: $_id, locale: $locale, message: $message) {
      _id
    }
  }
`;
